import * as React from 'react';
import { baseUrl } from '../baseUrl';
import { styled} from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
// import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreIcon from '@mui/icons-material/MoreVert';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
// import MyplayerLogo from '../images/MyPlayerLogo.png';
// import CircularProgress from '@mui/material/CircularProgress';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import Privacy from './Privacy';
import Footbar from './Footer';
import { useLocation } from 'react-router-dom';

const themeOptions = {
    palette: {
      type: 'light',
      primary: {
        main: 'rgb(255, 53, 3)',
      },
      secondary: {
        main: 'rgb(0, 0, 0)',
      },
    },
  };


const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(0),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    backgroundColor: themeOptions.palette.primary.main,
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'center',
}));


const drawerWidth = 200;
const sidebar_icon = [HomeOutlinedIcon, LeaderboardOutlinedIcon, NotificationAddOutlinedIcon, PersonOutlineOutlinedIcon, CategoryOutlinedIcon,EditNotificationsOutlinedIcon]
export default function SendNotifications() {
    const location = useLocation();
    const { username } = location.state || '';
    const {loginStatus} =location.state || false;
    useEffect(()=>{
        if (loginStatus){
        onload();
        }
        else{
            navigate('/cms');
        }
    },[]);
    
    const theme = createTheme(themeOptions);
    const [open, setOpen] = useState(false);
    const [drawerOpen, setDraweropen] = useState(false);
    const navigate = useNavigate();
    const [openNotification, setOpennotification] = useState('');
    const [body, setBody] = useState('');
    const [title, setTitle] = useState('');
    const [row, setRow] = useState([]);
    const [userSelected, setUserselected] = React.useState([]);
    const [addCategory, setAddCategory] = useState('')
    const [homeCategory, setHomeCategory] = useState('')
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);


    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleLogout = async () => {
        try {
            if (loginStatus) {
                navigate('/cms');
                // setLogoutStatus('Logout successful');
            } else {
                // setLogoutStatus('Logout unsuccessful');
                alert("Logout unsuccessful")
                window.location.reload(true)
            }
        } catch (error) {
            alert("An error occurred during logout")
            console.error('Error:', error);
            //   setLogoutStatus('An error occurred during logout');
        }
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleLogout}>LogOut</MenuItem>
            {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <LogoutIcon />
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );

    // const handleSendNotification = async () => {
    //     setOpennotification(true);
    // };

    const handleBodyChange = (event) => {
        setBody(event.target.value);
    }

    const handletitleChange = (event) => {
        setTitle(event.target.value);
    }

    // onload
    const onload = async () => {
        try {
            const result = await axios.get(`${baseUrl}userdetails_notification`)
            const datas = result.data.data.map((res) => ({ id: res.user_id, email_id: res.email_id, device_id: res.device_id }));
            // console.log(datas);
            setRow(datas)
            // console.log(row)
        }
        catch (e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    }
    // onload()

    const handleSend = async () => {
        setOpennotification(false);
        try {
            const response = await axios.post(`${baseUrl}send_notification`, { user: userSelected, title: title, body: body });
            const data = await response.data;
            if (data.status === 200) {
                navigate('/cms/homepage');
            }
        }
        catch (e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    };

    const handleCancelNotification = async () => {
        setOpennotification(false);
    }

    const handleCategory = async () => {
        setAddCategory(true);
    }

    const handleCancelCategory = async () => {
        setAddCategory(false)
    }

    const handleCategorychange = async (event) => {
        setHomeCategory(event.target.value);
    }

    const handleAddCategory = async () => {
        setAddCategory(false);
        try {
            const response = await axios.post(`${baseUrl}addcategory`, { category_name: homeCategory });
            const data = await response.data;
        }
        catch (e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    }

    const columns = [
        { field: 'id', headerName: 'User ID', width: 100, sortable: false, },
        { field: 'email_id', headerName: 'Email ID ', width: 200, sortable: false },
        { field: 'device_id', headerName: 'Device ID', width: 225, sortable: false }];

    const handleDrawerToggle = () => {
        setDraweropen(!drawerOpen);
          };


    return (
        <>
        <ThemeProvider theme={theme}>
            <Box sx={{ flexGrow: 1 }}>
                <CssBaseline />
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={drawerOpen}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerToggle}
                            edge="start"
                            sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div">
                            MyPlayer
                        </Typography>

                        <Box sx={{ flexGrow: 1 }} />
                        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

                        <Typography variant="h6" noWrap component="div" sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            {username}
                        </Typography>

                            <IconButton
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                color="inherit"
                            >
                                <LogoutIcon />
                            </IconButton>   
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={handleMobileMenuOpen}
                                color="inherit"
                            >
                                <MoreIcon />
                            </IconButton>
                        </Box>

                    </Toolbar>
                </AppBar>
                {renderMobileMenu}
                {renderMenu}
                
                <Drawer
                    variant="persistent"
                    anchor="left"
                    open={drawerOpen}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                >
                    <DrawerHeader>
                        {/* <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton> */}
                        <img style={{width:'50px',height:'50px',marginRight: '1px'}} src={"https://beeitech.com/images/logo/appicon.png"} alt='logo'/>
                    </DrawerHeader>
                    <Divider />
                    <List>

                        <ListItem key="Home" disablePadding>
                            <ListItemButton component={Link} to='/homescreen'state={{ username: username ,loginStatus:loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[0])}
                                </ListItemIcon>
                                <ListItemText primary="Home Screen" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem key="Dashboard" disablePadding>
                            <ListItemButton component={Link} to="/dashboard" state={{ username: username,loginStatus:loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[1])}
                                </ListItemIcon>
                                <ListItemText primary="Dashboard" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem class="drawer-select" key="Send Notification" disablePadding>
                            <ListItemButton onClick={() => window.location.reload(true)}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[2])}
                                </ListItemIcon>
                                <ListItemText primary="Send Notification" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem key="Users" disablePadding>
                            <ListItemButton component={Link} to="/userpage" state={{ username: username,loginStatus:loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[3])}
                                </ListItemIcon>
                                <ListItemText primary="Users" />
                            </ListItemButton>
                        </ListItem>

                        {/* <ListItem key="Category" disablePadding>
                            <ListItemButton onClick={handleCategory}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[4])}
                                </ListItemIcon>
                                <ListItemText primary="Add Category" />
                            </ListItemButton>
                        </ListItem> */}

                        <ListItem key ="Notifications Config" disablePadding>
                            <ListItemButton component={Link} to="/notificationsconfig" state={{ username: username,loginStatus:loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[5])}
                                </ListItemIcon>
                                <ListItemText primary="Notifications Config" />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <Divider />
                    <Privacy />

                    <Dialog open={addCategory} onClose={handleCancelCategory}>
                    <div style={{height: '300px', width: '500px' }}>
                        <DialogTitle>Add Category</DialogTitle>
                        <DialogContent>
                            <TextField id="name" label="Name" margin="dense" type="name" fullWidth autoFocus variant="standard" onChange={handleCategorychange} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCancelCategory} >CANCEL</Button>
                            <Button onClick={handleAddCategory}>ADD</Button>
                        </DialogActions>
                    </div>
                    </Dialog>

                </Drawer >

                <Main open={drawerOpen}>
                <DrawerHeader />
                    
                    <Box sx={{ marginLeft: '200px', marginRight: '1px', height: '100vh',width:'auto' }}>

                        <Box sx={{ display: 'flex', flexDirection: 'row', marginLeft: '2px', marginRight: '2px', justifyContent: 'space-evenly',height: '100vh' }}>
                           <Box>                          
                                <DataGrid
                                    rows={row}
                                    columns={columns}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setUserselected(newRowSelectionModel);
                                    }}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                                      }
                                />
                            </Box>
                            <Box sx={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',height:'300px',border:'10px solid  rgba(255, 51, 0, 0.747)'}}>
                                <DialogTitle>Send Notifications</DialogTitle>
                                <DialogContent>       
                                    <TextField id="standard-basic" label="Title" defaultValue="Listen Top Songs Only On MyPlayer!" fullWidth autoFocus variant="standard" value={title} onChange={handletitleChange} />
                                    <TextField id="standard-basic" label="Body" defaultValue="MyPlayer" fullWidth autoFocus variant="standard" value={body} onChange={handleBodyChange} />
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="outlined" startIcon={<CancelIcon/>} onClick={handleCancelNotification}>CANCEL</Button>
                                    <Button variant="outlined" endIcon={<SendIcon />} onClick={handleSend}>Send</Button>
                                </DialogActions>
                            </Box>
 

                        </Box>
                    </Box>
                    <Divider/>
                    <Footbar />    
                </Main>
                
            </Box>
        </ThemeProvider>
    </>
  );
}

